import { dateStatusType } from '../types';

export interface IMobileHeader {
  label: string;
  sortMetric: string;
  sortOrder: 'asc' | 'desc';
  value: string;
}

const dateDesc: IMobileHeader = {
  label: 'Date (Late to Early)',
  sortMetric: 'date',
  sortOrder: 'desc',
  value: 'date',
};

const dateAsc: IMobileHeader = {
  label: 'Date (Early to Late)',
  sortMetric: 'date',
  sortOrder: 'asc',
  value: 'date',
};

const getMobileItems = (dateStatus: dateStatusType): IMobileHeader[] => {
  const date =
    dateStatus === 'past' ? [dateDesc, dateAsc] : [dateAsc, dateDesc];
  return [
    ...date,
    {
      label: 'Tour name (A-Z)',
      sortMetric: 'tourName',
      sortOrder: 'asc',
      value: 'tourName',
    },
    {
      label: 'Tour name (Z-A)',
      sortMetric: 'tourName',
      sortOrder: 'desc',
      value: 'tourName',
    },
    {
      label: 'Venue (A-Z)',
      sortMetric: 'venue',
      sortOrder: 'asc',
      value: 'venue',
    },
    {
      label: 'Venue (Z-A)',
      sortMetric: 'venue',
      sortOrder: 'desc',
      value: 'venue',
    },
  ];
};

export default getMobileItems;
